module.exports = __webpack_public_path__ + "static/headerBg.5a352fb2.svg";


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/LocationsPage/headerBg.svg
// module id = 805
// module chunks = 0